import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services";

@Injectable({
    providedIn: "root",
})
export class AdminGuard implements CanActivate {

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // Guard for user is login or not
        let user = JSON.parse(localStorage.getItem("user"));
        if (!user) {
            this.router.navigate(["/auth/login"], { queryParams: { returnUrl: state.url } });
            return true;
        }
        return true;
    }
}
